<form [formGroup]="formName">
        <div class="relative input-number-wrapper">
            <p-inputNumber [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [min]="field?.validation?.min" mode="decimal" [maxFractionDigits]="5" class="w-full" [placeholder]="placeholder"> </p-inputNumber>
             <i class="{{miIcons.SETTINGS_PERCENT}} inline-block wh-22 percent-icon"></i>
        </div>
</form>
